import config from '@/common/config'

export default {
  data: function() {
    return {
      rules: {
        required: (v) => !!v || this.$t('input.inputRequiredValidationText'),
        min: (v) =>
          (!!v && v.length >= config.get('password.minChars')) ||
          this.$t('input.passwordRuleMinCharacters', {
            min: config.get('password.minChars'),
          }),
        uppercase: (v) =>
          (!!v && v.toLowerCase() !== v) ||
          this.$t('input.passwordRuleUpperCase'),
        lowercase: (v) =>
          (!!v && v.toUpperCase() !== v) ||
          this.$t('input.passwordRuleLowerCase'),
        number: (v) =>
          (!!v && /\d/.test(v)) || this.$t('input.passwordRuleNumber'),
        passwordsMatch: (v) =>
          (!!v && v === this.newPass) || this.$t('input.passwordRuleMustMatch'),
        special: (v) =>
          (!!v && config.get('password.allowedCharsRegex').test(v)) ||
          this.$t('input.passwordRuleSpecialCharacter'),
        email: (v) =>
          /.+@.+/.test(v) || this.$t('input.emailRequiredValidationText'),
      },
    }
  },
  methods: {
    /**
     * Should be paired with this form definition <v-form @keydown.enter.native="submit" ... />
     * Use this submit helper if your form doesn't have a button inside of it
     * (@submit.prevent won't work if there isn't a button within the form)
     * @param {*} payload
     * @param {String} emit
     */
    submit(payload, emit = 'submit') {
      this.$emit(emit, payload)
    },
  },
}
